import IndiaMap from "./IndiaMap";
import { Eyebrow, Reveal } from "./Reveal";

const CITY_NAMES = [
  "Chandigarh", "Delhi NCR", "Jaipur", "Lucknow", "Guwahati", "Ahmedabad",
  "Indore", "Kolkata", "Bhubaneswar", "Mumbai", "Pune", "Hyderabad",
  "Goa", "Chennai", "Bengaluru", "Kochi",
];

export default function Coverage() {
  return (
    <section id="coverage" className="border-t border-hairline py-12 sm:py-16" data-testid="coverage-section">
      <div className="grid site-x grid-cols-1 items-start gap-12 lg:grid-cols-[5fr_6fr]">
        <Reveal>
          <Eyebrow>Coverage</Eyebrow>
          <h3 className="mt-4 font-head font-extrabold tracking-tight h-sec">
            Teams across India.
          </h3>
          <p className="mt-4 max-w-md text-base leading-relaxed text-sub">
            We work nationwide and travel to clients anywhere in India. The
            date depends on the city and the size of the space; we give you a
            date on the call.
          </p>
          <p className="mt-8 text-[0.625rem] font-semibold uppercase tracking-[0.16em] text-violet">
            Coverage includes
          </p>
          <ul className="mt-3 grid grid-cols-2 gap-x-6 gap-y-2.5" data-testid="coverage-city-list">
            {CITY_NAMES.map((name) => (
              <li key={name} className="flex items-center gap-2.5 text-[0.6875rem] uppercase tracking-[0.16em] text-sub">
                <span className="h-1.5 w-1.5 rounded-full bg-violet" />
                {name}
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="rounded-xl border border-hairline bg-surface p-5 sm:p-7">
            <IndiaMap />
            <p className="mt-4 border-t border-hairline pt-3 text-[0.625rem] uppercase tracking-[0.16em] text-sub">
              Fig. 03 — Teams across India, sixteen cities
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
